import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const GOOGLE_AUTH_RETURN_PATH_KEY = "lotq_google_auth_return_path";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithGoogle, acceptExternalToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const hashParams = new URLSearchParams(hash.substring(1));
      const authToken = hashParams.get("auth_token");
      const sessionId = hashParams.get("session_id");

      if (!authToken && !sessionId) {
        console.error("No auth token found in URL");
        navigate("/", { replace: true });
        return;
      }

      try {
        if (authToken) {
          await acceptExternalToken(authToken);
        } else {
          await loginWithGoogle(sessionId);
        }
        const returnPath = window.localStorage.getItem(GOOGLE_AUTH_RETURN_PATH_KEY) || window.location.pathname || "/";
        window.localStorage.removeItem(GOOGLE_AUTH_RETURN_PATH_KEY);
        window.history.replaceState({}, "", returnPath);
        navigate(returnPath, { replace: true });
      } catch (error) {
        console.error("Auth error:", error);
        window.localStorage.removeItem(GOOGLE_AUTH_RETURN_PATH_KEY);
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [navigate, loginWithGoogle, acceptExternalToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#fccf1f] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white font-nunito">A autenticar...</p>
      </div>
    </div>
  );
}
